import { axios } from "../utils/axios";

const baseUrl = process.env.REACT_APP_API_HOST;

const moduleURL = "hcc-speciality";

export const getHCCDropdownOptions = async () => {
    try {
        const res = await axios.get(`${baseUrl}/${moduleURL}/dropdown-options`);
        return res;
    } catch (error) {
        throw error;
    }
};

export const addHCCSpeciality = async (data) => {
    try {
        const res = await axios.post(`${baseUrl}/${moduleURL}`, data);
        return res;
    } catch (error) {
        throw error;
    }
};


export const editHCCSpeciality = async (data, id) => {
    try {
        const res = await axios.put(`${baseUrl}/${moduleURL}/${id}`, data);
        return res;
    } catch (error) {
        throw error;
    }
};

export const getHCCSpecialityData = async ({ filters, page, size }) => {
    try {
        const res = await axios.post(`${baseUrl}/${moduleURL}/records?page=${page}&size=${size}`, filters);
        return res;
    } catch (error) {
        throw error;
    }
};

export const getHCCSpecialityMasterCodes = async ({ data }) => {
    try {
        const res = await axios.post(`${baseUrl}/${moduleURL}/master-codes`, data);
        return res;
    } catch (error) {
        throw error;
    }
};

export const fetchHCCSpecialityById = async (id) => {
    try {
        const res = axios.get(`${baseUrl}/${moduleURL}/${id}`);
        return res;
    } catch (e) {
        throw e;
    }
};

export const uploadHCCReport = async(form, date) => {
    return new Promise((resolve, reject) => {
        fetch(`${baseUrl}/${moduleURL}/upload-report?date=${date}`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
            body: form,
        })
        .then(async(response) => {
            return response.json();
        })
            .then(data => {
                resolve(data);
        })
        .catch(error => {
            reject(new Error('Failed to upload HCC report', error));
        });
    });
};

export const exportHCCReport = async(filters) => {
    return new Promise((resolve, reject) => {
        fetch(`${baseUrl}/${moduleURL}/export-report`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(filters),
        })
        .then(async(response) => {
            return response.json();
        })
            .then(data => {
                resolve(data);
        })
        .catch(error => {
            reject(new Error('Failed to upload HCC report', error));
        });
    });
};

export const deleteHCCRecord = async (id) => {
    try {
        const res = await axios.delete(`${baseUrl}/${moduleURL}/${id}`);
        return res;
    } catch (error) {
        throw error;
    }
};
